import React, {useState} from "react";
import "./SliderEvents.css";

const SliderEvents = function (props) {
    let sortedEvents = props.data.slice(0,4);
    return (       
        <React.Fragment>   
            <div className="titleAndLink">
                <div className="titleContainer">
                    <h3 className="closeEventsMainTitle">אירועים קרובים</h3>
                </div>
                <div className="linkContainer">
                    <a href={props.allEventsLink} className="allEventsLink" title="לכל האירועים" >לכל האירועים</a>
                </div>
            </div>
            <div className="allCloseEvents">
            {
                sortedEvents.map((event, idx) => 
                <div className="singleEvent" key={idx}>
                    <div className="singleEventIn">
                        <div className="imgEventContainer">
                            <a href={event.MuseumEventImg_Url} target="_blank">
                                <img className="imgSingleEvent" src={event.MuseumEventImg_Url} data-holder-rendered="true"  alt={event.MuseumEventName}/>
                            </a>
                        </div>
                        <div className="infoEventContainer">
                            <span className="closeEventTitle">{event.Title}</span>
                            <span className="closeEventDate" >{moment(event.MuseumEventStartDate).format('DD/MM/YYYY')}</span>

                        </div>
                    </div>    
                </div>)
            }
            </div>
        </React.Fragment>
    );
}

export default SliderEvents;
